/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";

export const KillswitchHistoryAction = {
  Created: "created",
  Edited: "edited",
  Lifted: "lifted",
  Expired: "expired",
  Restored: "restored",
} as const;
export type KillswitchHistoryAction = OpenEnum<typeof KillswitchHistoryAction>;

/** @internal */
export const KillswitchHistoryAction$inboundSchema: z.ZodMiniType<
  KillswitchHistoryAction,
  unknown
> = openEnums.inboundSchema(KillswitchHistoryAction);
